import React from 'react';
import { Route, withRouter } from 'react-router';
import LogUploadForm from "./components/logUploadForm";


const LogUpload = () => {
    return (
        <>
            <Route path="/log-upload" component={withRouter(LogUploadForm)} />
        </>
    )
};

export default LogUpload;